import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'

// ------------------------------------
// Constants
// ------------------------------------
export const BANK_CARD_BIND_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_FINISH: null,
  QUERY_EXPIRE: null,
  CONVERT_STATUS: null,
}, 'BANK_CARD_BIND_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data, count) {
  return (dispatch, getState) => {
    if (count === 5) {
      Toast.loading('', 0)
      dispatch({ type: BANK_CARD_BIND_RESULT.QUERY_EXPIRE, payload: false })
    }
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: data.cardId
          ? 'cgs/personal/card/detail/query'
          : 'cgs/cashdesk/queryBindCardResult',
        requestAction: BANK_CARD_BIND_RESULT.INIT_REQUEST,
        successAction: BANK_CARD_BIND_RESULT.INIT_SUCCESS,
        success: function(result) {
          if (getState().router.location.pathname !== '/bankcard/bind-result') {
            Toast.hide()
            return
          }
          if (count === 0) {
            Toast.hide()
            dispatch({
              type: BANK_CARD_BIND_RESULT.QUERY_EXPIRE,
              payload: true,
            })
            return
          }
          dispatch({
            type: BANK_CARD_BIND_RESULT.CONVERT_STATUS,
            payload: result,
          })
          if (result.status === 'UNACTIVE' || result.bindCardResult === 'UN') {
            // 处理中继续轮询
            setTimeout(() => {
              count--
              dispatch(init(data, count))
            }, 3000)
            return
          }
          Toast.hide()
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANK_CARD_BIND_RESULT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_BIND_RESULT.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_BIND_RESULT.QUERY_EXPIRE]: (state, action) =>
    Object.assign({}, state, { queryExpire: action.payload }),
  [BANK_CARD_BIND_RESULT.CONVERT_STATUS]: (state, action) => {
    if (action.payload.bindCardResult) {
      const DICT = {
        UN: 'UNACTIVE',
        F: 'DISABLED',
        S: 'NORMAL',
      }
      return Object.assign({}, state, {
        status: DICT[action.payload.bindCardResult],
      })
    }
    return state
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankCardBindResult',
    reducerMap: {
      bankCardBindResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
